import { render, staticRenderFns } from "./EmailSummary.vue?vue&type=template&id=38c6e940&scoped=true"
import script from "./EmailSummary.vue?vue&type=script&lang=js"
export * from "./EmailSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c6e940",
  null
  
)

export default component.exports